// designer-view.js

import $ from 'jquery';
import contentTemplate from 'designer/header-view.ejs';
import sequenceService from 'SequenceService';
import constants        from 'Constants';
import ContextMenuController from 'ContextMenuController';
import BaseMainView     from 'BaseMainView';
import eventBus             from 'EventBus';
import formService      from 'FormService.js';
import groupController      from 'GroupController.js';
import listService          from 'ListService.js';
import util                 from 'util/Util.js';
import quickHelp from 'QuickHelpView';

//=============================================================================
// Begin executing the top-level report UI.
//
// -Lou Mauget, March 16, 2016
//
//=============================================================================
class ReportView extends BaseMainView {

    initialize( opts ) {
        this.options = opts || {};
        this.$el = $(constants.CONTENT_ID);
        this.template = contentTemplate;
        this.events = {
            'click #designerAddNewPage' : 'addNewPage',
            'click #designerAddGroup' : 'addGroup'
        };

        return this;
    }


    //==========================================================
    // Create a page, reopen the layout with it as the
    // current page.
    //==========================================================
    addNewPage( evt ) {
        formService.addPage();
    }

    //==========================================================
    // Create a group which includes current selected objects.
    //==========================================================
    addGroup( evt ) {
        groupController.toggleGroup(listService.selected);
    }


    //==========================================================
    // Impose well-known DOM IDs for use by Q/A test automation.
    // JQuery is our friend.
    //==========================================================
    injectTestIds() {

        const selector = '.factory-widget-icon';
        const prefix = 'RPI_';

        super.injectTestIds( selector, prefix );


        const selector2 = '.factory-widget-text';
        const prefix2= 'RPT_';

        super.injectTestIds( selector2, prefix2 );

    }

    //==========================================================
    // Compose the page
    //==========================================================
    initPage(formProperties) {

        sequenceService.resetTabIndex();
        sequenceService.resetZIndex();

        this._contextMenu = new ContextMenuController().menu;

        this.listenTo(this.model, 'change', this.render);

        this.initMenu(constants.KIND_REPORT);
        this.initReportToolbarPane();
        util.enableSaveOption();
        this.initEditorContent(constants.KIND_REPORT, formProperties);
    }


    render(formProperties) {

        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));
        this.initPage(formProperties);

        this.injectTestIds();

        util.printHeader(listService.dashboardLayout.mainPanelView.model);
        const quickHelpView = new quickHelp({el:".quick-help-view", type: 'report', helpLink: ""});
        quickHelpView.render();

        this.delegateEvents();

        return this;
    }

    removeUnused() {
        if (this._contextMenu) {
            this._contextMenu.destroy();
        }
    }
    
    remove() {
        this._contextMenu.destroy();
        super.remove();
    }

}

export default ReportView;
